// Live catalog pulled from peptidesdirect.uk (Shopify products.json)
window.PRODUCTS = [
 {
  "handle": "glp-3rt",
  "title": "Retatrutide",
  "from": 57.9,
  "strengths": [
   "10MG",
   "20MG",
   "50MG"
  ],
  "category": "GLP / Metabolic",
  "bestseller": true,
  "img": PD_ASSET+"video-still_reta.webp",
  "tag": "The flagship. Independently tested, COA published online.",
  "desc": "Retatrutide is a next-generation research peptide designed as a triple agonist targeting GLP-1, GIP, and glucagon receptors",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 57.9
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 260.55
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 434.25
   },
   {
    "strength": "20MG",
    "pack": "Buy 1",
    "price": 99.99
   },
   {
    "strength": "20MG",
    "pack": "Buy 5",
    "price": 449.96
   },
   {
    "strength": "20MG",
    "pack": "Buy 10",
    "price": 749.93
   },
   {
    "strength": "50MG",
    "pack": "Buy 1",
    "price": 229.6
   },
   {
    "strength": "50MG",
    "pack": "Buy 5",
    "price": 1033.2
   },
   {
    "strength": "50MG",
    "pack": "Buy 10",
    "price": 1722.0
   }
  ]
 },
 {
  "handle": "ghk-cu",
  "title": "GHK-CU",
  "from": 12.9,
  "strengths": [
   "50MG",
   "100MG"
  ],
  "category": "Recovery & Repair",
  "bestseller": true,
  "img": PD_ASSET+"video-still_ghk.webp",
  "tag": "Copper peptide. Independently HPLC-verified.",
  "desc": "GHK-CU is a tripeptide composed of glycine, histidine, and lysine, naturally occurring in human plasma",
  "variants": [
   {
    "strength": "50MG",
    "pack": "Buy 1",
    "price": 12.9
   },
   {
    "strength": "50MG",
    "pack": "Buy 5",
    "price": 58.05
   },
   {
    "strength": "50MG",
    "pack": "Buy 10",
    "price": 96.75
   },
   {
    "strength": "100MG",
    "pack": "Buy 1",
    "price": 26.9
   },
   {
    "strength": "100MG",
    "pack": "Buy 5",
    "price": 121.05
   },
   {
    "strength": "100MG",
    "pack": "Buy 10",
    "price": 201.75
   }
  ]
 },
 {
  "handle": "bpc-157",
  "title": "BPC-157",
  "from": 14.9,
  "strengths": [
   "5MG",
   "10MG"
  ],
  "category": "Recovery & Repair",
  "bestseller": true,
  "img": PD_ASSET+"video-still_bpc.webp",
  "tag": "Every batch third-party tested.",
  "desc": "BPC-157 is a synthetic peptide derived from a protective protein found in gastric juice",
  "variants": [
   {
    "strength": "5MG",
    "pack": "Buy 1",
    "price": 14.9
   },
   {
    "strength": "5MG",
    "pack": "Buy 5",
    "price": 67.05
   },
   {
    "strength": "5MG",
    "pack": "Buy 10",
    "price": 111.75
   },
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 23.9
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 107.55
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 179.25
   }
  ]
 },
 {
  "handle": "mots-c",
  "title": "MOTS-C",
  "from": 19.9,
  "strengths": [
   "10MG",
   "40MG"
  ],
  "category": "Recovery & Repair",
  "bestseller": true,
  "img": PD_ASSET+"video-still_mots.webp",
  "tag": "Traceable batch number to certificate.",
  "desc": "MOTS-C is a mitochondrial-derived peptide studied for its potential to support metabolic function and cellular energy production",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 19.9
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 89.55
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 149.25
   },
   {
    "strength": "40MG",
    "pack": "Buy 1",
    "price": 55.7
   },
   {
    "strength": "40MG",
    "pack": "Buy 5",
    "price": 250.65
   },
   {
    "strength": "40MG",
    "pack": "Buy 10",
    "price": 417.75
   }
  ]
 },
 {
  "handle": "tirzepatide",
  "title": "Tirzepatide",
  "from": 47.2,
  "strengths": [
   "10MG",
   "40MG",
   "100MG"
  ],
  "category": "GLP / Metabolic",
  "bestseller": true,
  "img": PD_ASSET+"img-products-tirzepatide.jpg",
  "tag": "Verified purity, UK-dispatched.",
  "desc": "Tirzepatide is a dual GLP-1 and GIP receptor agonist designed to support metabolic health and weight management",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 47.2
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 212.4
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 354.0
   },
   {
    "strength": "40MG",
    "pack": "Buy 1",
    "price": 97.3
   },
   {
    "strength": "40MG",
    "pack": "Buy 5",
    "price": 437.85
   },
   {
    "strength": "40MG",
    "pack": "Buy 10",
    "price": 729.75
   },
   {
    "strength": "100MG",
    "pack": "Buy 1",
    "price": 180.0
   },
   {
    "strength": "100MG",
    "pack": "Buy 5",
    "price": 810.0
   },
   {
    "strength": "100MG",
    "pack": "Buy 10",
    "price": 1350.0
   }
  ]
 },
 {
  "handle": "nad",
  "title": "NAD+",
  "from": 39.7,
  "strengths": [
   "500MG",
   "1000MG"
  ],
  "category": "Longevity",
  "bestseller": true,
  "img": PD_ASSET+"img-products-nad.jpg",
  "tag": "Lab-tested, certificate published for every batch.",
  "desc": "NAD+ is a coenzyme found naturally in every cell, playing a crucial role in energy metabolism and cellular repair processes",
  "variants": [
   {
    "strength": "500MG",
    "pack": "Buy 1",
    "price": 39.7
   },
   {
    "strength": "500MG",
    "pack": "Buy 5",
    "price": 178.65
   },
   {
    "strength": "500MG",
    "pack": "Buy 10",
    "price": 297.75
   },
   {
    "strength": "1000MG",
    "pack": "Buy 1",
    "price": 76.0
   },
   {
    "strength": "1000MG",
    "pack": "Buy 5",
    "price": 342.0
   },
   {
    "strength": "1000MG",
    "pack": "Buy 10",
    "price": 570.0
   }
  ]
 },
 {
  "handle": "5-amino-1mq",
  "title": "5-AMINO-1MQ",
  "from": 22.8,
  "strengths": [
   "5MG",
   "10MG"
  ],
  "category": "GLP / Metabolic",
  "bestseller": false,
  "img": PD_ASSET+"img-products-5-amino-1mq.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "5-AMINO-1MQ is a research peptide designed for laboratory and scientific investigation",
  "variants": [
   {
    "strength": "5MG",
    "pack": "Buy 1",
    "price": 22.8
   },
   {
    "strength": "5MG",
    "pack": "Buy 5",
    "price": 102.6
   },
   {
    "strength": "5MG",
    "pack": "Buy 10",
    "price": 171.0
   },
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 36.6
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 164.7
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 274.5
   }
  ]
 },
 {
  "handle": "bpc-157-tb-500",
  "title": "BPC-157 & TB-500",
  "from": 30.0,
  "strengths": [
   "5MG",
   "10MG"
  ],
  "category": "Recovery & Repair",
  "bestseller": false,
  "img": PD_ASSET+"img-products-bpc-157-tb-500.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "BPC-157 and TB-500 or the \"WOLVERINE STACK\" represents a complementary peptide blend designed for advanced research applications",
  "variants": [
   {
    "strength": "5MG",
    "pack": "Buy 1",
    "price": 30.0
   },
   {
    "strength": "5MG",
    "pack": "Buy 5",
    "price": 135.0
   },
   {
    "strength": "5MG",
    "pack": "Buy 10",
    "price": 225.0
   },
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 52.0
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 234.0
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 390.0
   }
  ]
 },
 {
  "handle": "bacteriostatic-water",
  "title": "Bacteriostatic Water 0.9% B/A",
  "from": 5.8,
  "strengths": [
   "10ML"
  ],
  "category": "Essentials",
  "bestseller": false,
  "img": PD_ASSET+"img-products-bacteriostatic-water.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "Bacteriostatic water is sterile, pyrogen-free water containing 0.9% benzyl alcohol as a preservative",
  "variants": [
   {
    "strength": "10ML",
    "pack": "Buy 1",
    "price": 5.8
   },
   {
    "strength": "10ML",
    "pack": "Buy 5",
    "price": 26.1
   },
   {
    "strength": "10ML",
    "pack": "Buy 10",
    "price": 43.5
   }
  ]
 },
 {
  "handle": "cjc-1295-dac",
  "title": "CJC-1295 (DAC)",
  "from": 37.9,
  "strengths": [
   "10MG"
  ],
  "category": "Longevity",
  "bestseller": false,
  "img": PD_ASSET+"img-products-cjc-1295-dac.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "CJC-1295 with DAC (Drug Affinity Complex) is a synthetic growth hormone-releasing hormone (GHRH) analogue designed for research purposes",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 37.9
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 170.55
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 284.25
   }
  ]
 },
 {
  "handle": "ghrp-2",
  "title": "GHRP-2",
  "from": 15.0,
  "strengths": [
   "10MG"
  ],
  "category": "Growth",
  "bestseller": false,
  "img": PD_ASSET+"img-products-ghrp-2.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "GHRP-2 (Growth Hormone Releasing Peptide-2) is a synthetic hexapeptide designed to stimulate the release of growth hormone from the anterior pituitary gland",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 15.0
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 67.5
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 112.5
   }
  ]
 },
 {
  "handle": "ghrp-6",
  "title": "GHRP-6",
  "from": 15.0,
  "strengths": [
   "10MG"
  ],
  "category": "Growth",
  "bestseller": false,
  "img": PD_ASSET+"img-products-ghrp-6.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "GHRP-6 is a growth hormone releasing peptide designed to support natural growth hormone production",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 15.0
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 67.5
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 112.5
   }
  ]
 },
 {
  "handle": "bpc-157-copy-1",
  "title": "GLOW BLEND",
  "from": 38.6,
  "strengths": [
   "50MG",
   "70MG"
  ],
  "category": "Aesthetics",
  "bestseller": false,
  "img": PD_ASSET+"img-products-bpc-157-copy-1.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "50MG Blend: 30MG GHK-CU, 10MG BPC-157, 10MG TB-500 70MG Blend: 50MG GHK-CU, 10MG BPC-157, 10MG TB-500 GLOW Blend is a premium peptide formulation designed to support skin radiance ",
  "variants": [
   {
    "strength": "50MG",
    "pack": "Buy 1",
    "price": 38.6
   },
   {
    "strength": "50MG",
    "pack": "Buy 5",
    "price": 173.7
   },
   {
    "strength": "50MG",
    "pack": "Buy 10",
    "price": 289.5
   },
   {
    "strength": "70MG",
    "pack": "Buy 1",
    "price": 57.9
   },
   {
    "strength": "70MG",
    "pack": "Buy 5",
    "price": 260.55
   },
   {
    "strength": "70MG",
    "pack": "Buy 10",
    "price": 434.25
   }
  ]
 },
 {
  "handle": "bpc-157-copy",
  "title": "HGH 191aa",
  "from": 35.0,
  "strengths": [
   "10IU",
   "36IU",
   "50IU"
  ],
  "category": "Growth",
  "bestseller": false,
  "img": PD_ASSET+"img-products-bpc-157-copy.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "The Gold Standard of peptides, it is shown to enhance recovery, sleep, strength, potentiates muscle gain, fat loss, in adolescents and children it is used to increase height",
  "variants": [
   {
    "strength": "10IU",
    "pack": "Buy 1",
    "price": 35.0
   },
   {
    "strength": "10IU",
    "pack": "Buy 5",
    "price": 160.0
   },
   {
    "strength": "10IU",
    "pack": "Buy 10",
    "price": 250.0
   },
   {
    "strength": "36IU",
    "pack": "Buy 1",
    "price": 59.0
   },
   {
    "strength": "36IU",
    "pack": "Buy 5",
    "price": 275.0
   },
   {
    "strength": "36IU",
    "pack": "Buy 10",
    "price": 430.0
   },
   {
    "strength": "50IU",
    "pack": "Buy 1",
    "price": 70.0
   },
   {
    "strength": "50IU",
    "pack": "Buy 5",
    "price": 315.0
   },
   {
    "strength": "50IU",
    "pack": "Buy 10",
    "price": 485.0
   }
  ]
 },
 {
  "handle": "igf-1-lr3",
  "title": "IGF-1 LR3",
  "from": 65.0,
  "strengths": [
   "1MG"
  ],
  "category": "Recovery & Repair",
  "bestseller": false,
  "img": PD_ASSET+"img-products-igf-1-lr3.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "FOR IGF-1 PLEASE READ IGF-1 LR3 is a long-acting insulin-like growth factor variant designed for research purposes",
  "variants": [
   {
    "strength": "1MG",
    "pack": "Buy 1",
    "price": 65.0
   },
   {
    "strength": "1MG",
    "pack": "Buy 5",
    "price": 292.5
   },
   {
    "strength": "1MG",
    "pack": "Buy 10",
    "price": 487.5
   }
  ]
 },
 {
  "handle": "bpc-157-copy-2",
  "title": "KLOW BLEND",
  "from": 45.0,
  "strengths": [
   "80MG"
  ],
  "category": "Aesthetics",
  "bestseller": false,
  "img": PD_ASSET+"img-products-bpc-157-copy-2.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "KLOW BLEND is a premium peptide formulation designed to support metabolic function and cellular recovery",
  "variants": [
   {
    "strength": "80MG",
    "pack": "Buy 1",
    "price": 45.0
   },
   {
    "strength": "80MG",
    "pack": "Buy 5",
    "price": 202.5
   },
   {
    "strength": "80MG",
    "pack": "Buy 10",
    "price": 337.5
   }
  ]
 },
 {
  "handle": "mk-677",
  "title": "MK-677 100 Tabs",
  "from": 37.8,
  "strengths": [
   "10MG"
  ],
  "category": "GLP / Metabolic",
  "bestseller": false,
  "img": PD_ASSET+"img-products-mk-677.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "MK-677, also known as Ibutamoren, is a selective agonist of the ghrelin receptor designed for research purposes",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 37.8
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 170.1
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 283.5
   }
  ]
 },
 {
  "handle": "melanotan-1-mt-1-copy",
  "title": "Melanotan 1 (MT-1)",
  "from": 19.7,
  "strengths": [
   "10MG"
  ],
  "category": "Aesthetics",
  "bestseller": false,
  "img": PD_ASSET+"img-products-melanotan-1-mt-1-copy.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "Melanotan 1 (MT-1) is a synthetic peptide analogue of alpha-melanocyte-stimulating hormone (\u03b1-MSH)",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 19.7
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 88.65
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 147.75
   }
  ]
 },
 {
  "handle": "melanotan-2-mt-2",
  "title": "Melanotan 2 (MT-2)",
  "from": 19.7,
  "strengths": [
   "10MG"
  ],
  "category": "Aesthetics",
  "bestseller": false,
  "img": PD_ASSET+"img-products-melanotan-2-mt-2.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "Melanotan 2 is a synthetic peptide analogue of alpha-melanocyte-stimulating hormone (\u03b1-MSH)",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 19.7
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 88.65
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 147.75
   }
  ]
 },
 {
  "handle": "selank",
  "title": "SELANK",
  "from": 16.9,
  "strengths": [
   "5MG"
  ],
  "category": "Cognitive",
  "bestseller": false,
  "img": PD_ASSET+"img-products-selank.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "SELANK is a synthetic peptide derived from tuftsin, designed to support cognitive function and mental clarity",
  "variants": [
   {
    "strength": "5MG",
    "pack": "Buy 1",
    "price": 16.9
   },
   {
    "strength": "5MG",
    "pack": "Buy 5",
    "price": 76.05
   },
   {
    "strength": "5MG",
    "pack": "Buy 10",
    "price": 126.75
   }
  ]
 },
 {
  "handle": "semax",
  "title": "SEMAX",
  "from": 16.9,
  "strengths": [
   "5MG"
  ],
  "category": "Cognitive",
  "bestseller": false,
  "img": PD_ASSET+"img-products-semax.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "Semax is a synthetic heptapeptide derived from adrenocorticotropic hormone (ACTH)",
  "variants": [
   {
    "strength": "5MG",
    "pack": "Buy 1",
    "price": 16.9
   },
   {
    "strength": "5MG",
    "pack": "Buy 5",
    "price": 76.05
   },
   {
    "strength": "5MG",
    "pack": "Buy 10",
    "price": 126.75
   }
  ]
 },
 {
  "handle": "semaglutide",
  "title": "Semaglutide",
  "from": 25.8,
  "strengths": [
   "5MG",
   "10MG"
  ],
  "category": "GLP / Metabolic",
  "bestseller": false,
  "img": PD_ASSET+"img-products-semaglutide.jpg",
  "tag": "COA ships alongside every order.",
  "desc": "Semaglutide is a GLP-1 receptor agonist peptide used in research and clinical settings",
  "variants": [
   {
    "strength": "5MG",
    "pack": "Buy 1",
    "price": 25.8
   },
   {
    "strength": "5MG",
    "pack": "Buy 5",
    "price": 116.1
   },
   {
    "strength": "5MG",
    "pack": "Buy 10",
    "price": 193.5
   },
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 46.2
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 207.9
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 346.5
   }
  ]
 },
 {
  "handle": "tesamorelin",
  "title": "TESAMORELIN",
  "from": 29.9,
  "strengths": [
   "10MG"
  ],
  "category": "Longevity",
  "bestseller": false,
  "img": PD_ASSET+"img-products-tesamorelin.jpg",
  "tag": "Independently batch-tested. COA published online.",
  "desc": "Tesamorelin is a synthetic growth hormone-releasing hormone (GHRH) analogue designed to support natural growth hormone production",
  "variants": [
   {
    "strength": "10MG",
    "pack": "Buy 1",
    "price": 29.9
   },
   {
    "strength": "10MG",
    "pack": "Buy 5",
    "price": 134.55
   },
   {
    "strength": "10MG",
    "pack": "Buy 10",
    "price": 224.25
   }
  ]
 }
];
